/**
 * 下载进度轮询器
 */
import { pollingExportStatus } from "@/services/common.js";
import { triggerDownloadOSSFiles } from "@/utils/utils";
import contextApi from "@/utils/contextApi";

const defaultTimeOut = 60 * 10 * 1000; // 十分钟
const defaultInterval = 3 * 1000; // 几秒轮询
const defaultWatcher = (taskId, taskInfo) => {
  if (taskInfo.status === "completed") {
    console.log(`任务${taskId}已就绪，正在为您下载`);
    contextApi("message").success("导出下载任务已完成，正在为您下载");

    const { downloadUrl } = taskInfo;
    // 下载
    triggerDownloadOSSFiles(downloadUrl);
  }
};
class DownloadStatusPolling {
  constructor(
    pollingApi = pollingExportStatus,
    interval = defaultInterval,
    timeout = defaultTimeOut,
  ) {
    this.tasks = [];
    this.watcher = [defaultWatcher];
    this.interval = interval;
    this.timeout = timeout;
    this.pollingApi = pollingApi;
  }

  // 添加一个轮训任务
  addTask({ taskId }) {
    if (this.tasks.find((v) => v.taskId === taskId)) {
      throw new Error("taskId已经存在");
    }
    const taskInfo = {
      taskId,
      addTime: new Date().getTime(),
      status: "added",
    };
    this.tasks.push(taskInfo);
    this.setPolling(taskInfo);
  }

  // 设置轮询
  setPolling(taskInfo) {
    const { taskId, addTime } = taskInfo;
    const { tasks } = this;
    const { pollingApi } = this;
    const { timeout } = this;
    const { onChange } = this;
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const that = this;
    const updateTask = (_taskId, _info, _tasks) => {
      _tasks.forEach((v, i) => {
        if (v.taskId === _taskId) {
          _tasks[i] = {
            ..._tasks[i],
            ..._info,
          };
        }
      });
      onChange.bind(that)(_taskId, _info, _tasks);
    };
    const now = new Date().getTime();
    const intervalId = setInterval(async () => {
      let status = "processing";
      let downloadUrl;
      const res = await pollingApi(taskId);
      if (res.code === "200") {
        if (res.data.status === 1) {
          clearInterval(intervalId);
          status = "completed";
          // eslint-disable-next-line prefer-destructuring
          downloadUrl = res.data.downloadUrl;
        } else {
          if (now - addTime > timeout) {
            clearInterval(intervalId);
            status = "timeOut";
          }
        }
      } else {
        clearInterval(intervalId);
        status = "pollingApiError";
      }
      updateTask(taskId, {
        status,
        downloadUrl,
        lastUpdate: now,
      }, tasks);
    }, this.interval);
  }

  onChange(taskId) {
    const taskInfo = this.tasks.find((v) => v.taskId === taskId);
    const { tasks } = this;
    this.watcher.forEach((func) => {
      try {
        func(taskId, taskInfo, tasks);
      } catch {
        return false;
      }
    });
    // console.table(this.tasks)
  }

  // 添加订阅方法
  addWatcher(func) {
    this.watcher.push(func);
  }
}

export default DownloadStatusPolling;
